import { navigationPrefsOf, type NavigationPrefs } from '@kaba/shared';

export type Loc = { kind: 'planung' | 'uebersicht' | 'favoriten' | 'zuletzt' | 'alle' | 'meine' | 'unsortiert' | 'archiv' } | { kind: 'bereich'; id: string } | { kind: 'ordner'; id: string };

export const SIMPLE = ['planung', 'uebersicht', 'favoriten', 'zuletzt', 'alle', 'meine', 'unsortiert', 'archiv'] as const;

export function parseLoc(raw: string | null): Loc | null {
  if (!raw) return null;
  if ((SIMPLE as readonly string[]).includes(raw)) return { kind: raw as (typeof SIMPLE)[number] };
  const m = /^(bereich|ordner)-([0-9a-f-]{36})$/.exec(raw);
  return m ? { kind: m[1] as 'bereich' | 'ordner', id: m[2]! } : null;
}
export const locParam = (l: Loc) => ('id' in l ? `${l.kind}-${l.id}` : l.kind);

/** Direkte Links bleiben erreichbar. Ausgeblendete automatische Einstiege führen zu allen Boards. */
export function resolveHomeLocation(input: { explicit: string | null; legacyMine: boolean; startDashboardId: string | null; lastPlace: string | null; prefs?: Partial<NavigationPrefs> }): { loc: Loc; startDash: string | null } {
  const explicit = parseLoc(input.explicit);
  if (explicit) return { loc: explicit, startDash: null };
  if (input.legacyMine) return { loc: { kind: 'meine' }, startDash: null };
  const prefs = navigationPrefsOf(input.prefs);
  if (input.startDashboardId) return prefs.showOverview
    ? { loc: { kind: 'uebersicht' }, startDash: input.startDashboardId }
    : { loc: { kind: 'alle' }, startDash: null };
  const last = parseLoc(input.lastPlace);
  const hidden = (last?.kind === 'uebersicht' && !prefs.showOverview) || (last?.kind === 'planung' && !prefs.showPlanning);
  return { loc: hidden ? { kind: 'alle' } : last ?? { kind: 'alle' }, startDash: null };
}
